import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';

import Stack from '@mui/material/Stack';

const logoSize = '125px';

export const StyledLogo = styled(Box)({
  maxHeight: logoSize,
  maxWidth: logoSize
});

export const StyledProfileImage = styled(Avatar)({
  height: '50px',
  width: '50px'
});

export const StyledStackContainer = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'useLogo' || prop !== 'useProfile'
})(({ theme, useLogo, useProfile }) => ({
  position: 'absolute',
  top: 0,
  flexDirection: 'row',
  justifyContent: 'space-between',
  padding: '15px',
  width: '100vw',
  height: '160px',
  zIndex: '-1',
  [theme.breakpoints.down('lg')]: {
    padding: '20px 20px 100px',
    height: 'fit-content'
  },
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '25px',
    ...(!useLogo
      ? {
          '& .MuiBox-root:first-child': {
            display: 'none'
          }
        }
      : {}),
    ...(!useProfile
      ? {
          '& .MuiStack-root': {
            display: 'none'
          }
        }
      : {})
  }
}));

export const StyledStackProfileTitle = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '15px',
  height: 'min-content'
});

export const StyledStackLogo = styled(Box)(({ theme }) => ({
  width: logoSize,
  height: logoSize,
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

export const StyledStackTitle = styled(Stack)({
  alignItems: 'end',
  gap: '5px',
  fontSize: '14px',
  h6: {
    lineHeight: 1,
    fontSize: '1em'
  },
  p: {
    lineHeight: 1,
    fontSize: '.8em'
  }
});

export const StyledStackLandingWrapper = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'isSplash'
})(({ isSplash, theme }) => ({
  padding: '20px',
  background: ' #fff',
  border: '1px solid #ccc',
  borderRadius: ' 6px',
  margin: `${isSplash ? '76px' : '30px'} auto 30px`,
  width: '58.66%',
  section: {
    gridColumn: '2 / 3'
  },
  [theme.breakpoints.down('lg')]: {
    margin: `${isSplash ? '130px' : '30px'} auto`
  },
  [theme.breakpoints.down('md')]: {
    margin: `${isSplash ? '230px' : '30px'} auto`
  },
  [theme.breakpoints.down('sm')]: {
    width: `calc(100vw - 10px)`
  }
}));

export const StyledVpInfoBanner = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  backgroundColor: theme.palette.vpColors.blueBackgroundLight,
  border: '1px solid',
  borderColor: theme.palette.vpColors.blueMain,
  color: theme.palette.vpColors.blueMain,
  borderRadius: '6px',
  padding: '24px',
  marginTop: '24px',
  width: '100%',
  gap: '15px',
  alignItems: 'start',
  '& .MuiTypography-root': {
    color: theme.palette.vpColors.black
  }
}));



// WEBPACK FOOTER //
// ./src/containers/CampaignLandingPage/styles.js